module.exports = "<span class=\"ml-2 total__count \">Total: {{count}}</span>"